/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, isBanner }) => {
  const url = `https://event.dabangapp.com`;

  return (
    <Helmet>
      <meta name="description" content={description} />
      <meta name="keywords" content="원룸, 오피스텔, 투룸, 쓰리룸, 아파트, 다방앱, 다방어플, 부동산어플, 부동산앱, 혜리다방, 원룸사이트, 무보증원룸, 단기임대, 월세, 전세, 매매" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={`${title} - 다방 이벤트`} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content="http://static.dabangapp.com/img/opengraph.png" />
      <meta property="og:image:secure_url" content="https://static.dabangapp.com/img/opengraph.png" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="256" />
      <meta property="og:image:height" content="256" />
      <meta property="og:image:alt" content="원룸, 투룸, 오피스텔, 아파트까지 내가 원하는 방, 다방에 다 있다!" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={`${title} - 다방 이벤트`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="http://static.dabangapp.com/img/opengraph.png" />
      <meta name="twitter:domain" content="부동산 필수 앱 다방" />
      <meta name="twitter:creator" content="Station3, Inc." />

      <link rel="canonical" href={url} />

      <title>{title} {`${!isBanner ? '- 다방 이벤트' : ''}`}</title>
    </Helmet>
  );
};

SEO.defaultProps = {
  description: `원룸, 투룸, 오피스텔, 아파트까지 내가 원하는 방, 다방에 다 있다!`,
  isBanner: false,
};

SEO.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default SEO;
